import Vue from 'vue'
import App from './App'
import mixin from './mixin'
import router from './router'
import VueDragResize from 'vue-drag-resize'
// import draggable from 'vuedraggable'
import './ui.js'
//照片查看
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
var options = {
    mainClass:'zIndexClass'
};
 Vue.component('vue-drag-resize', VueDragResize)
//Vue.component('draggable', draggable)
Vue.use(preview,options)

Vue.mixin(mixin)
var vm = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js